import { render, staticRenderFns } from "./Congregazioni.vue?vue&type=template&id=4d439a7c&scoped=true&"
import script from "./Congregazioni.vue?vue&type=script&lang=js&"
export * from "./Congregazioni.vue?vue&type=script&lang=js&"
import style0 from "./Congregazioni.vue?vue&type=style&index=0&id=4d439a7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d439a7c",
  null
  
)

export default component.exports